import React from 'react';
import { Switch } from 'react-router-dom';
import { FormattedHTMLMessage } from 'react-intl';
import './styles.css';
import { Route } from 'react-router-dom';
import {
	SALES,
	PRODUCTION,
	PROCUREMENT,
	INCOMESTATEMENT,
	BALANCESHEET,
	CASHFLOW,
	EXPORTREPORTS
} from '../../routes';
const BusinessPlanSectionTitle = () => (
	<div className="business-plan-section-title">
		<Switch>
			<Route
				path={SALES}
				render={() => <FormattedHTMLMessage id="sales-title" />}
			/>
			<Route
				path={PRODUCTION}
				render={() => <FormattedHTMLMessage id="production-title" />}
			/>
			<Route
				path={PROCUREMENT}
				render={() => <FormattedHTMLMessage id="procurement-title" />}
			/>
			<Route
				path={INCOMESTATEMENT}
				render={() => <FormattedHTMLMessage id="income-statement-title" />}
			/>
			<Route
				path={BALANCESHEET}
				render={() => <FormattedHTMLMessage id="balance-sheet-title" />}
			/>
			<Route
				path={CASHFLOW}
				render={() => <FormattedHTMLMessage id="cash-flow-title" />}
			/>
			<Route
				path={EXPORTREPORTS}
				render={() => <FormattedHTMLMessage id="export-reports-title" />}
			/>
		</Switch>
	</div>
);

export default BusinessPlanSectionTitle;
